const en = {
  colPart: 'Part',
  colOrderNumber: 'Order Number',
  colPurchase: 'Purchase',
  colSelling: 'Selling',
  outOfStock: 'Out of Stock',
  lowStock: 'Low Stock',
  inStock: 'In Stock',
  nla: 'NLA',
  partStatus: 'Availability',
  available: 'Available',
  nlaLong: 'NLA – no longer available',
  editPart: 'Edit Part',
  saveChanges: 'Save Changes',
  deletePart: 'Delete Part',
  confirmDeleteMessage: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
};

const de = {
  colPart: 'Teil',
  colOrderNumber: 'Bestellnummer',
  colPurchase: 'Einkauf',
  colSelling: 'Verkauf',
  outOfStock: 'Nicht auf Lager',
  lowStock: 'Niedriger Bestand',
  inStock: 'Auf Lager',
  nla: 'NLA',
  partStatus: 'Verfügbarkeit',
  available: 'Verfügbar',
  nlaLong: 'NLA – nicht mehr lieferbar',
  editPart: 'Teil bearbeiten',
  saveChanges: 'Änderungen speichern',
  deletePart: 'Teil löschen',
  confirmDeleteMessage: 'Möchten Sie "{{name}}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
};

const partsTable = { en, de };
export default partsTable;
